import React from 'react';
import { connect } from 'react-redux';
import { confirmTokenRevoke, toggleTokenSelected } from '../actions';
import TokenRow from '../components/TokenRow';

const TokensTableRows = ({
  category,
  items,
  onCheckBoxClick,
  showRevoke,
  columns,
}) => (
  items.map((item, index) => (
    <TokenRow
      key={`tokens_table_row_${item.code}`}
      category={category}
      token={item}
      onCheckBoxClick={onCheckBoxClick}
      showRevoke={showRevoke}
      upward={index > 4}
      columns={columns}
    />
  ))
);

const mapDispatchToProps = {
  onCheckBoxClick: toggleTokenSelected,
  showRevoke: confirmTokenRevoke,
};

export default connect(null, mapDispatchToProps)(TokensTableRows);
